import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCateringEventBySlugApiResponseSchema = z.object({
    data: z.array(z.object({
        documentId: z.string(),
        name: z.string(),
        slug: z.string(),
        description: z.any(),
        images: z.array(
            z.object({
                url: z.string(),
            }),
        ).optional().nullable(),
        format: z.object({
            name: z.string(),
        }).optional().nullable(),
    })),
});

type GetCateringEventBySlugActionResponse
    = ApiResponse<z.infer<typeof GetCateringEventBySlugApiResponseSchema>>
    | BaseError;

type GetCateringEventBySlugActionRequest = {
    slug: string,
}

export const getCateringEventBySlug = createAsyncThunk<
    GetCateringEventBySlugActionResponse,
    GetCateringEventBySlugActionRequest
>(
    'CateringEventPageActionsGetCateringEventBySlug',
    async ({
        slug,
    }) => apiInstance.get(
        '/catering-events',
        {
            'filters[slug][$eq]': slug,
            'populate[images][fields]': 'url',
            'populate[format][fields]': '*',
        },
        GetCateringEventBySlugApiResponseSchema,
    ),
);
